import script from "./MysticAltarPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticAltarPanel.vue?vue&type=script&setup=true&lang=js"

import "./MysticAltarPanel.vue?vue&type=style&index=0&id=102b53e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-102b53e5"]])

export default __exports__